import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import './SCUIGeneralModal.scss';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { SCUIGeneralModalFooter } from '../../molecules';

export const SCUIGeneralModal = (props: any) => {
    return (
        <Dialog
            className={props.rootClassName}
            open={props.open}
            onClose={props.onClose}
            maxWidth={props.width ? props.width : 'md'}
            fullWidth
            disableEnforceFocus={true}
            sx={
                props.sx
                    ? props.sx
                    : {
                          '.MuiPaper-root': {
                              padding: 2,
                          },
                      }
            }
            onKeyUp={props.onKeyUP && props.onKeyUP}
            slotProps={{
                paper: {
                    ...(props.paperClassName ? { className: props.paperClassName } : {}),
                },
            }}
        >
            <DialogTitle
                className={props.titleClassName}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 3,
                    fontSize: '14px !important',
                    fontWeight: 700,
                }}
            >
                {props.title}
                <IconButton className={props.closeIconButtonClassName} sx={{ ml: 'auto' }}>
                    <CloseIcon
                        className={['svg_icons', props.closeIconClassName].filter(Boolean).join(' ')}
                        onClick={props.onClose}
                    />
                </IconButton>
            </DialogTitle>
            {props.children}
            {props.functionButtonOnClick && (
                <SCUIGeneralModalFooter
                    autoFocusButton={props.autoFocusButton}
                    onclose={props.onClose}
                    functionButtonOnClick={props.functionButtonOnClick}
                    buttonText={props.buttonText}
                    disabled={props.disabled}
                />
            )}
        </Dialog>
    );
};
